'use strict';

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgExternalLink = props => /*#__PURE__*/React__namespace.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  overflow: "visible",
  preserveAspectRatio: "none",
  viewBox: "0 0 24 24",
  height: 24,
  width: 24
}, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M17.33 13.67a.317.317 0 0 0-.3-.34h-.7c-.18-.01-.32.13-.33.31V17c0 .92-.75 1.67-1.67 1.67H5.67C4.75 18.67 4 17.92 4 17V8.34c0-.92.75-1.67 1.67-1.67H13c.18.01.32-.13.33-.31v-.69c.01-.18-.13-.32-.31-.33H5.67a2.9 2.9 0 0 0-2.12.88 2.9 2.9 0 0 0-.88 2.12V17c-.01.8.31 1.57.88 2.12a2.9 2.9 0 0 0 2.12.88h8.66c1.66 0 3-1.34 3-3v-3.33zm4-9a.683.683 0 0 0-.67-.67h-5.33c-.36 0-.66.29-.67.65 0 .18.07.35.2.48L16.7 7l-6.79 6.76c-.13.13-.14.33-.01.47l.01.01 1.19 1.19c.13.13.33.14.47.01l.01-.01 6.79-6.79 1.83 1.83c.27.25.69.24.95-.03.11-.12.18-.28.18-.44V4.67z",
  vectorEffect: "non-scaling-stroke",
  fill: "currentColor"
})));

exports["default"] = SvgExternalLink;
